

<ng-container *ngIf="hospid">
    <div class="container-fluid">
        <div>
            <h6 class="title">
                Leap Frog Report Place Holder
            </h6>
            <p></p><br>

            <div class="form-group">
                <!-- DATE FILTERS-->
                Select a timeline for which the reports should be downloaded:
                <label>
                    <input type="radio" name="date" value="male" [(ngModel)]="selectedDate"> 01/01/2022 to 12/31/2022
                  </label>
                  
                  <label>
                    <input type="radio" name="date" value="female" [(ngModel)]="selectedDate"> 07/01/2022 to 06/30/2022
                  </label>

                <!-- STAFFING-SKILL-LEVEL && RN-EDUCATION-->
                  <nav>           
                    <div class="nav nav-tabs customTabber" id="nav-tab" role="tablist">
                      <a class="nav-item nav-link active" id="nav-staffing-skill-level-tab" data-bs-toggle="tab" href="#nav-staffing-skill-level" role="tab"
                        aria-controls="nav-staffing-skill-level" aria-selected="true">Staffing Skill Level</a>
                      <a *ngIf="showTab" class="nav-item nav-link" id="nav-rn-education-tab" data-bs-toggle="tab" href="#nav-rn-education" role="tab"
                        aria-controls="nav-rn-education" aria-selected="false">RN Education</a>
                    </div> 
                  </nav>
  
                  <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="nav-staffing-skill-level" role="tabpanel" aria-labelledby="nav-staffing-skill-level">
                      <app-staffing-skill-level> 
                      </app-staffing-skill-level>
                    </div>
  
                    <div class="tab-pane fade" id="nav-rn-education" role="tabpanel" aria-labelledby="nav-rn-education-tab">                    
                      <app-rn-education> 
                      </app-rn-education>
                    </div>
                  </div>  
            </div>

        </div>
    </div>
</ng-container>